import api from './api';

const base = '/admin/funcionarios';

export async function listFuncionarios({
  q = '',
  page = 1,
  limit = 25,
  unidade,
  ativo,
} = {}) {
  const params = { q, page, limit };
  if (unidade) params.unidade = unidade;
  if (ativo) params.ativo = ativo;
  const { data } = await api.get(base, { params });
  return data;
}

export async function createFuncionario(payload) {
  const { data } = await api.post(base, payload);
  return data;
}

export async function updateFuncionario(codFunc, payload) {
  const { data } = await api.put(`${base}/${codFunc}`, payload);
  return data;
}

export async function deleteFuncionario(codFunc) {
  const { data } = await api.delete(`${base}/${codFunc}`);
  return data;
}
